<mat-card class="form-padding" >
    <div style="text-align: center;">
        <img src="../../../../assets/images/404_Illustration_Male-ai.svg" alt=""
            style="display: flex; width: 400px; margin: auto;">
        <mat-card-title style="margin-bottom: 50px;">SOMETHING WENT WRONG <br><br> NOT FOUND ERROR 404</mat-card-title>
    </div>
</mat-card>

